import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Nimi

  <span style="color:#85c1dc;">**FI:**</span>
  Nimi

  <span style="color:#85c1dc;">**RU:**</span>
  Имя
*/
/* @__NO_SIDE_EFFECTS__ */
const m443 = msg(
  mf`Nimi`,
  mf`Nimi`,
  mf`Имя`,
)

export { m443 as 'w.klient.name' }